import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-gateway-dialog',
  templateUrl: './gateway-dialog.component.html',
  styleUrls: ['./gateway-dialog.component.css']
})
export class GatewayDialogComponent implements OnInit {


  reshtml: any;
  response: any;
  formname: any;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
  private elementRef: ElementRef,   @Inject(DOCUMENT) public document) { }

  ngOnInit() {
    this.response = this.data['data'];
    this.formname = this.data['form'];
    this.reshtml = this.response.response;
    const d1 = this.elementRef.nativeElement.querySelector('.result');
    d1.insertAdjacentHTML('beforeend', this.reshtml);
    setTimeout(() => {
      this.document.getElementById(this.formname).submit();
    }, 500);
  }

}
